const STORAGE_KEY = "axon-acquisition-v2";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const HOME_PLACEMENTS = new Set(["hero_poster", "pain", "proof", "start"]);
const CONSENT_COOKIE = "axon_analytics_consent_v2=1";

function hasSiteAnalyticsConsent(cookieString) {
  return typeof cookieString === "string"
    && cookieString.split(";").some((part) => part.trim() === CONSENT_COOKIE);
}

/** Запоминаем только известные места перехода, без URL, referrer и личных данных. */
export function captureAcquisition(
  search,
  storage,
  now = Date.now(),
  cookieString = globalThis.document?.cookie,
) {
  if (!hasSiteAnalyticsConsent(cookieString)) return null;
  const params = new URLSearchParams(search || "");
  if (params.get("utm_source") !== "axonleads_site") return null;

  const medium = params.get("utm_medium");
  const content = params.get("utm_content");
  const placement = medium === "home" && HOME_PLACEMENTS.has(content)
    ? content
    : medium === "header"
      ? "header"
      : medium === "article"
        ? "article"
        : null;
  if (!placement || !Number.isFinite(now)) return null;

  const value = {
    acquisitionSource: "axonleads_site",
    acquisitionMedium: medium,
    acquisitionPlacement: placement,
  };
  try {
    (storage || globalThis.sessionStorage)?.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...value, capturedAt: now }),
    );
  } catch {
    // Аналитика не должна блокировать вход при запрете sessionStorage.
  }
  return value;
}

export function readAcquisition(
  storage,
  now = Date.now(),
  cookieString = globalThis.document?.cookie,
) {
  if (!hasSiteAnalyticsConsent(cookieString)) return null;
  try {
    const stored = JSON.parse((storage || globalThis.sessionStorage)?.getItem(STORAGE_KEY) || "null");
    if (!stored || !Number.isFinite(stored.capturedAt)
      || now < stored.capturedAt || now - stored.capturedAt > MAX_AGE_MS) return null;
    const { acquisitionSource, acquisitionMedium, acquisitionPlacement } = stored;
    if (acquisitionSource !== "axonleads_site"
      || (acquisitionMedium === "home" && !HOME_PLACEMENTS.has(acquisitionPlacement))
      || (acquisitionMedium === "header" && acquisitionPlacement !== "header")
      || (acquisitionMedium === "article" && acquisitionPlacement !== "article")
      || !["home", "header", "article"].includes(acquisitionMedium)) return null;
    return { acquisitionSource, acquisitionMedium, acquisitionPlacement };
  } catch {
    return null;
  }
}
